<span *ngIf="stage && label" class="status-badge spiritual-stage-badge spiritual-stage-badge--{{ stage | lowercase }}">
  {{ label }}
</span>
